import React, { useCallback, useEffect, useState } from "react";
import {
  Alert,
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import api from "../api/axios";
import { useAuth } from "../context/AuthContext";

const ExpenseList = ({ refreshKey = 0 }) => {
  const { user } = useAuth();
  const { enqueueSnackbar } = useSnackbar();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchExpenses = useCallback(async () => {
    if (!user?.agency_id) return;

    try {
      setLoading(true);

      const res = await api.get("/expenses", {
        params: { agency_id: user.agency_id },
      });

      setRows(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      enqueueSnackbar("Échec du chargement des dépenses", {
        variant: "error",
      });
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, [user?.agency_id, enqueueSnackbar]);

  useEffect(() => {
    fetchExpenses();
  }, [fetchExpenses, refreshKey]);

  return (
    <Paper sx={{ p: 3, borderRadius: 3 }}>
      <Typography variant="h6" sx={{ fontWeight: 800, mb: 2 }}>
        Historique des dépenses
      </Typography>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      ) : rows.length === 0 ? (
        <Alert severity="info">Aucune dépense enregistrée.</Alert>
      ) : (
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Catégorie</TableCell>
                <TableCell>Bénéficiaire</TableCell>
                <TableCell>Montant</TableCell>
                <TableCell>Devise</TableCell>
                <TableCell>Statut</TableCell>
                <TableCell>Créé par</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow key={row.id} hover>
                  <TableCell>{row.expense_date || "-"}</TableCell>
                  <TableCell>{row.category || "-"}</TableCell>
                  <TableCell>{row.beneficiary_name || "-"}</TableCell>
                  <TableCell>{row.amount ?? "-"}</TableCell>
                  <TableCell>{row.currency || "-"}</TableCell>
                  <TableCell>{row.status || "-"}</TableCell>
                  <TableCell>{row.created_by_name || "-"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  );
};

export default ExpenseList;